import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
} from "@mui/material";
import { displayValue } from "../../helpers/TodayDate";
import CaddeSokakAPI from "../../apis/OB/Get/CaddeSokakAPI";
import BinaBildirimListeAPI from "../../apis/OB/Get/BinaBildirimListeAPI";
import ArsaBildirimListeAPI from "../../apis/OB/Get/ArsaBildirimListeAPI";
import AraziBildirimListeAPI from "../../apis/OB/Get/AraziBildirimListeAPI";
import { Oval } from "react-loader-spinner";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";
import CloseIcon from "@mui/icons-material/Close";
import PaginationComponent from "./PaginationComponent";
import CustomTextField from "./required-text-field";

const GayrimenkulBulPopUp = (props: any) => {
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
  const [selectedMahalle, setSelectedMahalle] = useState<any>(0);
  const [selectedCaddeSokak, setSelectedCaddeSokak] = useState<any>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [aramaKriterleri, setAramaKriterleri] = useState<any>(0);
  const [ada, setAda] = useState<any>(null);
  const [parsel, setParsel] = useState<any>(null);
  const [pafta, setPafta] = useState<any>("");
  const [tapuBagimsizBolumNo, setTapuBagimsizBolumNo] = useState<any>("");
  const [kapiNo, setKapiNo] = useState<any>("");
  const [data, setData] = useState<any[]>([]);
  const [errors, setErrors] = useState<any>({});
  const [isSearched, setIsSearched] = useState<boolean>(false);

  /*Pagination Items*/
  const [currentPage, setCurrentPage] = useState(1);

  const [currentRecords, setCurrentRecords] = useState<any[]>([]);
  const [pageNumbers, setPageNumbers] = useState<any[]>([]);
  useEffect(() => {
    const newPageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(data.length / (props.recordsPerPage || 10));
      i++
    ) {
      newPageNumbers.push(i);
    }
    setPageNumbers(newPageNumbers);
  }, [data, (props.recordsPerPage || 10)]);
  useEffect(() => {
    const indexOfLastRecord = currentPage * (props.recordsPerPage || 10);
    const indexOfFirstRecord = indexOfLastRecord - (props.recordsPerPage || 10);
    setCurrentRecords(data.slice(indexOfFirstRecord, indexOfLastRecord));
    console.log(data);
  }, [currentPage, data, (props.recordsPerPage || 10)]);

  useEffect(() => {
    if (selectedMahalle !== 0) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalle)
        .then((res) => {
          setCaddeSokakDatas(res.data);
        })
        .catch((err) => { });
    } else {
      setCaddeSokakDatas([]);
    }
  }, [selectedMahalle]);

  const handleAdaChange = (event: any) => {
    const { value } = event.target;
    if (value === "") {
      setAda(null);
    } else if (value.match(/^[0-9]+$/)) {
      setAda(Number(value.substring(0, 10)));
    }
  };

  const handleParselChange = (event: any) => {
    const { value } = event.target;
    if (value === "") {
      setParsel(null);
    } else if (value.match(/^[0-9]+$/)) {
      setParsel(Number(value.substring(0, 10)));
    }
  };

  const validateInputs = () => {
    const newErrors: any = {};
    if (aramaKriterleri === 0) {
      if (!selectedMahalle) newErrors.selectedMahalle = true;
      if (!selectedCaddeSokak) newErrors.selectedCaddeSokak = true;
    } else if (aramaKriterleri === 1) {
      if (!ada) newErrors.ada = true;
      if (!parsel) newErrors.parsel = true;
    } else if (aramaKriterleri === 2 && props.type === "1") {
      if (!tapuBagimsizBolumNo) newErrors.tapuBagimsizBolumNo = true;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fethData = () => {
    if (!validateInputs()) return;

    let paftaa = pafta !== "" ? pafta : undefined;
    let tapuBagimsizBolumNoo =
      tapuBagimsizBolumNo !== "" ? tapuBagimsizBolumNo : undefined;
    let kapiNoo = kapiNo !== "" ? kapiNo : undefined;
    let adaa = ada !== null ? ada : undefined;
    let parsell = parsel !== null ? parsel : undefined;
    let selectedMahallee = selectedMahalle !== 0 ? selectedMahalle : undefined;
    let selectedCaddeSokakk =
      selectedCaddeSokak !== 0 ? selectedCaddeSokak : undefined;
    switch (props.type) {
      case "1":
        if (
          (adaa !== undefined && parsell !== undefined) ||
          (selectedMahallee !== undefined &&
            selectedCaddeSokakk !== undefined) ||
          tapuBagimsizBolumNoo !== undefined
        ) {
          setIsLoading(true);
          BinaBildirimListeAPI.getBinaBildirimListeListe(
            paftaa,
            tapuBagimsizBolumNoo,
            kapiNoo,
            adaa,
            parsell,
            selectedMahallee,
            selectedCaddeSokakk
          )
            .then((res) => {
              setData(res.data);
              setIsSearched(true);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
            });
        } else {
          alert("Lütfen Tüm Alanları Doldurunuz.");
        }
        break;
      case "2":
        if (
          (adaa !== undefined && parsell !== undefined) ||
          (selectedMahallee !== undefined &&
            selectedCaddeSokakk !== undefined) ||
          tapuBagimsizBolumNoo !== undefined
        ) {
          setIsLoading(true);
          ArsaBildirimListeAPI.getArsaBildirimListe(
            paftaa,
            adaa,
            parsell,
            selectedMahallee,
            selectedCaddeSokakk
          )
            .then((res) => {
              setData(res.data);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
            });
        } else {
          alert("Lütfen Tüm Alanları Doldurunuz.");
        }
        break;
      case "3":
        if (
          (adaa !== undefined && parsell !== undefined) ||
          (selectedMahallee !== undefined &&
            selectedCaddeSokakk !== undefined) ||
          tapuBagimsizBolumNoo !== undefined
        ) {
          setIsLoading(true);

          AraziBildirimListeAPI.getAraziBildirimListe(
            paftaa,
            adaa,
            parsell,
            selectedMahallee,
            selectedCaddeSokakk
          )
            .then((res) => {
              setData(res.data);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
            });
        } else {
          alert("Lütfen Tüm Alanları Doldurunuz.");
        }

        break;
    }
  };

  const clearAllInput = () => {
    setAda(null);
    setParsel(null);
    setPafta("");
    setTapuBagimsizBolumNo("");
    setKapiNo("");
    setSelectedMahalle(0);
    setSelectedCaddeSokak(0);
    setData([]);
    setErrors({});
  };

  useEffect(() => {
    clearAllInput();
  }, [aramaKriterleri]);

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          // Dialog'un iç kağıdı üzerinde stil uygulama
          m: "0.5rem", // margin değerini sıfırla
          maxWidth: "100%", // Maksimum genişliği %100 yap, ekranı tam kaplasın
          width: "100%", // Genişliği %100 yap
          maxHeight: "100vh", // Maksimum yüksekliği viewport'un %100'ü yap
        },
      }}
      fullWidth={true}
      maxWidth="xl"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle justifyContent={"space-between"} id="dialog-title">
        {"Gayrimenkul Bul"}
        <IconButton
          aria-label="close"
          onClick={() => props.onClose(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme: any) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: "0.4rem" }}>
        <div className="d-flex flex-wrap align-self-strech justify-content-between mb-3 mt-2 w-100">
          <div className="d-flex flex-wrap  gap-1">
            <TextField
              className="mb-2"
              size="small"
              select
              label="Arama Kriteri"
              value={aramaKriterleri}
              onChange={(e) => setAramaKriterleri(Number(e.target.value))}
              error={errors.aramaKriterleri}
              sx={{
                width: {
                  xs: "100%", // Full width on xs
                  sm: "100%", // Full width on sm
                  md: "auto", // Auto width on md and larger
                },
              }}
            >
              <MenuItem value={0}>{"Mahalle, Cadde/Sokak"}</MenuItem>
              <MenuItem value={1}>{"Pafta, Ada, Parsel"}</MenuItem>
              {props.type === 0 && (
                <MenuItem value={2}>{"Tapu Bağımsız No"}</MenuItem>
              )}
            </TextField>

            {aramaKriterleri === 0 && (
              <>
                <CustomTextField
                  size="small"
                  className="mb-2"
                  select
                  label="Mahalle *"
                  value={selectedMahalle}
                  onChange={(e: any) => setSelectedMahalle(Number(e.target.value))}
                  error={errors.selectedMahalle}
                  sx={{
                    width: {
                      xs: "100%", // Full width on xs
                      sm: "100%", // Full width on sm
                      md: "auto", // Auto width on md and larger
                    },
                  }}
                >
                  <MenuItem value={0}>{"Seçiniz.."}</MenuItem>
                  {mahalleListe.map((option) => (
                    <MenuItem
                      key={option.mahalleKodu}
                      value={option.mahalleKodu}
                    >
                      {option.mahalleAdi}
                    </MenuItem>
                  ))}
                </CustomTextField>
                <CustomTextField
                  size="small"
                  className="mb-2"
                  select
                  label="Cadde/Sokak *"
                  value={selectedCaddeSokak}
                  onChange={(e: any) =>
                    setSelectedCaddeSokak(Number(e.target.value))
                  }
                  error={errors.selectedCaddeSokak}
                  sx={{
                    width: {
                      xs: "100%", // Full width on xs
                      sm: "100%", // Full width on sm
                      md: "auto", // Auto width on md and larger
                    },
                  }}
                >
                  <MenuItem value={0}>{"Seçiniz.."}</MenuItem>
                  {caddeSokakDatas.map((option) => (
                    <MenuItem
                      key={option.caddeSokakKodu}
                      value={option.caddeSokakKodu}
                    >
                      {option.caddeSokakAdi}
                    </MenuItem>
                  ))}
                </CustomTextField>
              </>
            )}

            {aramaKriterleri === 1 && (
              <>
                <TextField
                  label="Pafta"
                  size="small"
                  placeholder="Pafta"
                  value={pafta}
                  className="mb-2"
                  variant="outlined"
                  onChange={(e) => setPafta(e.target.value)}
                  error={errors.pafta}
                  sx={{
                    width: {
                      xs: "100%", // Full width on xs
                      sm: "100%", // Full width on sm
                      md: "auto", // Auto width on md and larger
                    },
                  }}
                />
                <CustomTextField
                  label="Ada *"
                  size="small"
                  placeholder="Ada"
                  className="mb-2"
                  variant="outlined"
                  value={ada === null ? "" : ada}
                  onChange={handleAdaChange}
                  error={errors.ada}
                  sx={{
                    width: {
                      xs: "100%", // Full width on xs
                      sm: "100%", // Full width on sm
                      md: "auto", // Auto width on md and larger
                    },
                  }}
                />
                <CustomTextField
                  size="small"
                  label="Parsel *"
                  placeholder="Parsel"
                  className="mb-2"
                  variant="outlined"
                  value={parsel === null ? "" : parsel}
                  onChange={handleParselChange}
                  error={errors.parsel}
                  sx={{
                    width: {
                      xs: "100%", // Full width on xs
                      sm: "100%", // Full width on sm
                      md: "auto", // Auto width on md and larger
                    },
                  }}
                />
              </>
            )}

            {aramaKriterleri === 2 && props.type === "1" && (
              <TextField
                size="small"
                label="Tapu Bağımsız No"
                placeholder="Tapu Bağımsız No"
                className="mb-2"
                variant="outlined"
                value={tapuBagimsizBolumNo}
                onChange={(e) => setTapuBagimsizBolumNo(e.target.value)}
                error={errors.tapuBagimsizBolumNo}
                sx={{
                  width: {
                    xs: "100%", // Full width on xs
                    sm: "100%", // Full width on sm
                    md: "auto", // Auto width on md and larger
                  },
                }}
              />
            )}

            {aramaKriterleri !== 2 && props.type === "1" && (
              <TextField
                size="small"
                label="Kapı No (Opsiyonel)"
                placeholder="Kapı No (Opsiyonel)"
                className="mb-2"
                variant="outlined"
                value={kapiNo}
                onChange={(e) => setKapiNo(e.target.value)}
                sx={{
                  width: {
                    xs: "100%", // Full width on xs
                    sm: "100%", // Full width on sm
                    md: "auto", // Auto width on md and larger
                  },
                }}
              />
            )}
          </div>
          <div className="d-flex gap-1 align-self-strech flex-wrap">
            <Button
              onClick={fethData}
              size="small"
              className="mb-2"
              sx={{
                width: {
                  xs: "100%", // Full width on xs
                  sm: "100%", // Full width on sm
                  md: "auto", // Auto width on md and larger
                },
              }}
            >
              Ara
            </Button>
            <Button
              size="small"
              onClick={clearAllInput}
              className="mb-2"
              color="secondary"
              sx={{
                width: {
                  xs: "100%", // Full width on xs
                  sm: "100%", // Full width on sm
                  md: "auto", // Auto width on md and larger
                },
              }}
            >
              Temizle
            </Button>
          </div>
        </div>
        <div className="d-flex align-self-strech overflow-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <td></td>
                <td>Pafta</td>
                <td>Ada</td>
                <td>Parsel</td>
                <td>Mahalle/ Köyü</td>
                <td>Cadde/ Sokak</td>
                {props.type !== "1" && <td>Mevkii </td>}
                {props.type !== "3" && <td>Blok No/ Kat No</td>}
                {props.type !== "3" && <td>Tapu Bağımsız No</td>}
                {props.type !== "3" && <td>Kapı No/ Alt Kapı No</td>}
                {props.type !== "3" && <td>Daire No/Alt Daire No</td>}
                {props.type !== 3 && props.type === "1" && (
                  <td>Kullanım Şekli</td>
                )}
                {props.type !== 3 && props.type === "1" && <td>İnşaat Türü</td>}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={props.type === "1" ? 12 : 11}>
                    <Oval
                      visible={true}
                      height="80"
                      width="80"
                      color="#6E3FF3"
                      ariaLabel="oval-loading"
                      wrapperStyle={{ margin: "auto", marginTop: "1%" }}
                      wrapperClass=""
                    />
                  </td>
                </tr>
              ) : currentRecords.length !== 0 ? (
                currentRecords.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        color="success"
                        onClick={async () => {
                          await props.onSelectEmlak(data[index]);
                        }}
                      >
                        Seç
                      </Button>
                    </td>
                    <td>{displayValue(item.pafta)}</td>
                    <td>{displayValue(item.ada)}</td>
                    <td>{displayValue(item.parsel)}</td>
                    <td>{displayValue(item.mahalleAdi)}</td>
                    <td>{displayValue(item.caddeSokakAdi)}</td>
                    {props.type !== "1" && <td>{displayValue(item.mevkii)}</td>}
                    {props.type !== 3 && (
                      <td>
                        {displayValue(item.tapuBlokNo)} /{" "}
                        {displayValue(item.tapuKatNo)}
                      </td>
                    )}
                    <td>{displayValue(item.tapuBagimsizNo)}</td>
                    {props.type !== 3 && (
                      <td>
                        {displayValue(item.kapiNo)} /{" "}
                        {displayValue(item.altKapiNo)}
                      </td>
                    )}
                    {props.type !== 3 && (
                      <td>
                        {displayValue(item.daireNo)} /{" "}
                        {displayValue(item.altDaireNo)}
                      </td>
                    )}
                    {props.type !== 3 && props.type === "1" && (
                      <td>{displayValue(item.kullanimSekliAdi)}</td>
                    )}
                    {props.type !== 3 && props.type === "1" && (
                      <td>{displayValue(item.insaatTuruAdi)}</td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    style={{ textAlign: "start", fontSize: "1.0rem" }}
                    colSpan={props.type === "1" ? 12 : 11}
                  >
                    {isSearched ? "Yazdığınız kriterlere göre gayrimenkul bulunmamaktadır.Bu ekranı kapatarak, başvuru sayfamızdan başvurunuza devam edebilirsiniz." : "Lütfen Arama Yapınız."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <PaginationComponent
          pageNumbers={pageNumbers}
          dataCount={data.length}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </DialogContent>
    </Dialog>
  );
};

export default GayrimenkulBulPopUp;
